var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label,"item-text":_vm.itemText,"item-value":_vm.itemValue,"value":_vm.value,"rules":_vm.inputRules},on:{"input":function($event){return _vm.$emit('change-value', { name: _vm.name, value: $event })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }